import Game from "../../../../../src/Game";
import { rootEventBus, EnumRootEventBus } from "../../../../../src/managers/RootEventBus";
import { eventBus, EnumEventBus } from "./EventBus";
import InfoSlider from "../../../../../src/entities/InfoSlider/InfoSlider";
import Circle from "../../../../../src/entities/Circle";
import PointManager from "./PointManager/PointManager";
import PointTagManager from "./PointTagManager";
import LineManager from "./LineManager";
import AngleManager from "./AngleManager/AngleManager";
import SliderManager from "./SliderManager";
import CircleAnimationManager from "./CircleAnimationManager/CircleAnimationManager";
import GuideText from "../../../../../src/entities/GuideText";
import Kite from "../entities/Kite";
import GenRanIntersec from "../entities/GenRandomIntersection";

import isPortail from "../../../../../src/utils/isPortial";
import { ARC_COLOR_ARR, CENTER_OF_CIRCLE, CIRCLE_RADIUS, INFO_SLIDER_COORD, INITIAL_RADIANS } from "../types/Config";
import isCircumPointBetween from "../../../../../src/utils/isCircumPointBetween";
import KiteSwitcher from "../entities/KiteSwitcher";
import Triangle1Switcher from "../entities/Triangle1Switcher";
import Triangle2Switcher from "../entities/Triangle2Switcher";


export default class ComponentManager {
  static instance: ComponentManager;
  Game = Game.getInstance();
  circleRadius = CIRCLE_RADIUS;
  cCoord = isPortail(this.Game.getDim(), CENTER_OF_CIRCLE);

  SliderManager = new SliderManager();
  PointManager = new PointManager(this.cCoord);
  PointTagManager = new PointTagManager(this.cCoord);
  LineManager = new LineManager(this.cCoord);
  InfoSlider = new InfoSlider(INFO_SLIDER_COORD)
  AngleManager = new AngleManager(this.cCoord);
  circle = new Circle(this.cCoord, INITIAL_RADIANS, ARC_COLOR_ARR);
  CircleAnimationManager: CircleAnimationManager;
  kite = new Kite(this.cCoord);
  KiteModeSwitcher = new KiteSwitcher();
  Triangle1Switcher = new Triangle1Switcher();
  Triangle2Switcher = new Triangle2Switcher();
  KiteMode = false;

  constructor() {
    if (!ComponentManager.instance) {
      ComponentManager.instance = this;
    }
    new GuideText();
    new GenRanIntersec();

    this.CircleAnimationManager = new CircleAnimationManager(
      this.PointManager,
      this.AngleManager,
      this.LineManager,
      this.circle,
      this.cCoord
    );
    
    this.drawElements();
    rootEventBus.emit(EnumRootEventBus.getCircleCoord, this.cCoord);
    rootEventBus.on(EnumRootEventBus.drawElements, () => this.drawElements());
    eventBus.on(EnumEventBus.KiteMode, (v: boolean) => {
      this.KiteMode = v;
      this.drawElements();
    });

    eventBus.on(EnumEventBus.Triangle1Mode, () => this.drawElements());
    eventBus.on(EnumEventBus.Triangle2Mode, () => this.drawElements());
  }

  static getInstance = () => ComponentManager.instance;

  drawElements() {
    const radians = this.PointManager.getRadians();
    const redPointsCoord = this.PointManager.getRedPointsCoord();
    const interSecCoord = this.PointManager.getIntersecCoord();
    const isbtw = isCircumPointBetween(this.cCoord, interSecCoord, radians[0], radians[1]);
    const tangentCoords = this.PointManager.getTangentCoords(isbtw);

    this.circle.draw({ radians, radius: this.circleRadius });
    this.PointTagManager.updateCoord(radians, this.circleRadius)
    this.LineManager.draw(redPointsCoord, tangentCoords, interSecCoord);
    this.AngleManager.draw(redPointsCoord, interSecCoord, isbtw);
    this.KiteMode && this.kite.draw(redPointsCoord, interSecCoord);
  }
}